import React from "react";
import { SvgBox } from "@govlaunch/web";

export default function ChevronRight() {
  return (
    <SvgBox width="12px" height="24px" viewBox="0 0 12 24" fill="none">
      <path
        d="M1.5 22.5L9.75 12.2692L1.5 1.5"
        stroke="#086BE5"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgBox>
  );
}
